import { useOutletContext } from 'react-router-dom';

import { IMytaverseEventContext } from './interfaces';

export const useMytaverseEvent = () =>
  useOutletContext<IMytaverseEventContext>();
